


























import { modifyDetail } from "@/api/teacherManage";
import richTextEditor from "@/components/richTextEditor.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "teacherDetailsDescription",
  components: {
    richTextEditor,
  },
})
export default class extends Vue {
  @Prop() originData!: string;
  @Prop() readonly!: number;
  loaded: boolean = false;
  description: string = "";
  @Watch("originData", { immediate: false, deep: false })
  originDataChange(n: string, o: string) {
    if (o === undefined) {
      this.loaded = true;
      this.description = n;
    }
  }
  get editable() {
    return this.readonly === 1;
  }
  postedit() {
    const html = this.description
      .replace(/<\/?p[^>]*>/gi, "")
      .replace(/&nbsp;/g, "")
      .trim();
    if (html == "") {
      this.$message({
        type: "error",
        message: "请输入教师详情",
      });
      return;
    }
    modifyDetail({
      staff_id: Number(this.$route.query.id),
      detail: this.description,
    }).then((res: any) => {
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "保存成功",
        });
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
}
